import { render, staticRenderFns } from "./AssignDriversDrawer.vue?vue&type=template&id=83b25dba&scoped=true&"
import script from "./AssignDriversDrawer.vue?vue&type=script&lang=js&"
export * from "./AssignDriversDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AssignDriversDrawer.vue?vue&type=style&index=0&id=83b25dba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b25dba",
  null
  
)

export default component.exports